import React from 'react';

import { Skeleton, SkeletonText, Stack } from '@chakra-ui/react';

import style from './styles/GuideSekeleton.style';

const GuideSekeleton = () => {
  return (
    <Stack sx={style.root}>
      <SkeletonText skeletonHeight="5" className="guideSkeletonText1" />
      <SkeletonText className="guideSkeletonText3" skeletonHeight="3" />
      <Skeleton className="guideSkeleton" />
      <SkeletonText className="guideSkeletonText2" skeletonHeight="3" />
      <Skeleton className="guideSkeleton" />
      <SkeletonText className="guideSkeletonText3" skeletonHeight="3" />
    </Stack>
  );
};

export default GuideSekeleton;
